<template>
<div class="download-pdf">
    <a v-bind:href="link" title>
    <div class="download-pdf__icon"></div>
    <div class="download-pdf__content-wrapper">
        <div class="download-pdf__title">Download PDF</div>
        <div class="download-pdf__size">{{size || "unknown size"}}</div>
    </div>
    </a>
</div>
</template>

<script>
export default {
    name: "UXPdfButton",
    props: {
        link: String,
        size: String,
    },
    computed: {}
};
</script>
